export default {
  fi: {
    BusinessEditScene: {
      editInformation: 'Muokkaa yrityksen tietoja',
    },
  },
};
